
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq3hARhRdsp50IT6iQUZ0QZOzSzfLT33z_45vCGLPCQNrHQMeta } from "/codebuild/output/src2604562234/src/src/pages/faq.vue?macro=true";
import { default as menuypqbJzNE1j7m0uEKeHUpARnT3HStZ62JmEImt4YMBwkMeta } from "/codebuild/output/src2604562234/src/src/pages/menu.vue?macro=true";
import { default as indexouF9_0u07tkKWP0fVYb8QSX1XR85jbRqmpUIyaWDpI4Meta } from "/codebuild/output/src2604562234/src/src/pages/index.vue?macro=true";
import { default as contactT_C33zCWUnV5xu5T83IMQKQaAVv__45nY5nzIygzYg9hkMeta } from "/codebuild/output/src2604562234/src/src/pages/contact.vue?macro=true";
import { default as tutorialTy4LG1NgSfHM71ztBjerp0LE9EMauQKx8QERfCPVIRwMeta } from "/codebuild/output/src2604562234/src/src/pages/tutorial.vue?macro=true";
import { default as agreementoAL3uuLhallLxgds4z7B7Gek5Q7SN2foCUBWWAO8YIYMeta } from "/codebuild/output/src2604562234/src/src/pages/agreement.vue?macro=true";
import { default as about_45passy4LmmF6Q_45gyT1UZMQ4v4YNt3abOYCPjsyf7b37EUJhwMeta } from "/codebuild/output/src2604562234/src/src/pages/about-pass.vue?macro=true";
import { default as indexT_45pkXFIGxHbcdX9oq9lhfI0t_0494U9p_4536fXJGZdhcMeta } from "/codebuild/output/src2604562234/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93vpafxkwFhDopQLShgYrq3JBWAH54TqzSzcu1Z6kWVV4Meta } from "/codebuild/output/src2604562234/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceUs4ybR_45OS_EdlJeIMw290xBFm0i_45Am3sPX9DfAFGhhgMeta } from "/codebuild/output/src2604562234/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93rMzVTogrObDXZ9EwgfxP_45NE5nmrWXQzC6rUYFoTZ_45LUMeta } from "/codebuild/output/src2604562234/src/src/pages/notice/[id].vue?macro=true";
import { default as indexwsh449Ck1QwGknvslxowG7ql4wnqkaJhkcu4zER5qMQMeta } from "/codebuild/output/src2604562234/src/src/pages/coupon/index.vue?macro=true";
import { default as indexfMaK_WxVLxOeWtR5mHyR3XnThlK1eYgzqJcgjlwmjHIMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/index.vue?macro=true";
import { default as indexNwPwirS2G7qI9vNWxzJFqj_45b8Tp106VjoNq6rGhbUEcMeta } from "/codebuild/output/src2604562234/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93fVm5W_45nzg0fHBW0ZRyygh5qYQC1ne1GzfXCqYrJt0sEMeta } from "/codebuild/output/src2604562234/src/src/pages/parking/[id].vue?macro=true";
import { default as indexhe7gHpDDhDV87G_1XKUh34lQrvqIxwVttbHGv3mB8o8Meta } from "/codebuild/output/src2604562234/src/src/pages/history/index.vue?macro=true";
import { default as indexQOQAEnK8K9pbocOPbW6qxiqUXjqX2m1N_45ylkmcATrUsMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/index.vue?macro=true";
import { default as indexOlSUEua13u_UUrD4llpRJZdea5mR0utwDwQZ5QrBuBAMeta } from "/codebuild/output/src2604562234/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexvNszoyNTV2swXJmvAkvkDTVNgCW3MVryysXjRWhHtDsMeta } from "/codebuild/output/src2604562234/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavizmwLVkTTgnHVxuqWpK9CQ8nUvD9EVS05748_45smmmEWgMeta } from "/codebuild/output/src2604562234/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editPrHk9unuV7XkmSdz9v0R876bsZ2QGcXWs9_UZ9EenJAMeta } from "/codebuild/output/src2604562234/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementKL1nopj847Jq9J7M2jhSgBhYpEGZc6O7PntPoJhr_45AcMeta } from "/codebuild/output/src2604562234/src/src/pages/pass-agreement.vue?macro=true";
import { default as index9Ug8RS_XfGRl4ELjtnyUNpojJZhxPUENCAv2RxC9Hy0Meta } from "/codebuild/output/src2604562234/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dZnuKytN_45_45XDdH9Z_7ju0ExNRGWEpfJb2o1dCYIcjbqcMeta } from "/codebuild/output/src2604562234/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm95xYmKCQ1OTvdCGu5apikalIZdX735MupL7W5HPyoHQMeta } from "/codebuild/output/src2604562234/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index0pPJmi_45RXEu_45ZHd3haSe7wIRZhnMigBjzKZxFHodRpQMeta } from "/codebuild/output/src2604562234/src/src/pages/card/create/index.vue?macro=true";
import { default as indexHPPQfinJlJBfNbzY6QRzdgtE_451l6kWFtOIL2B_qFSewMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmpuuRZVnIb8iED3QfUeYwjnTKz9jXaqwSZsqIW3APyJgMeta } from "/codebuild/output/src2604562234/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm_45bY1jwcLK8ddH5TI_45vt7TY2vy6jvVcSOd8qj6w15eHQMeta } from "/codebuild/output/src2604562234/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completezK5_icwpfxcG3BwoAxIOUpdfTrTisqYFfoNZch3jLoIMeta } from "/codebuild/output/src2604562234/src/src/pages/membership/complete.vue?macro=true";
import { default as registerHITeyxU9jKADIjZm_45fnDzu4U8S_KPSDhsYatPMshVKMMeta } from "/codebuild/output/src2604562234/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93d6_GncUgGO0ORMlpt5nDDDEuAu_45iM9VEg0nhPI0GOM8Meta } from "/codebuild/output/src2604562234/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmbxNGGy2HZesYuLmsr5ENVLkbe4qdejk1DN5Q2Cptw2wMeta } from "/codebuild/output/src2604562234/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93OEm1IsdCgerBvqe8T8APDtqfxeUs2MhFK5jHeMvGNQwMeta } from "/codebuild/output/src2604562234/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexmSDGOJdR7dNY2TZU_DXL6FEniEYRjsfNML1yGJpwgcgMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codejLQ037v8TUu4dP7jKPzyWaHbhcaQgrxqx4g7V1woDK4Meta } from "/codebuild/output/src2604562234/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeL1_oW3hhjHw_45eSX88NtXGNfHcNvetYMouL3yL0sWvrsMeta } from "/codebuild/output/src2604562234/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeeS2gYtXJHCtofytaToUI_45TSTcUMWOCCH7ZzhP_459NJ8sMeta } from "/codebuild/output/src2604562234/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerUSBG2D27PyerU_45NziaVSHF_XmxT7vLwJhpPRVY1Rc4AMeta } from "/codebuild/output/src2604562234/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeL0w4Vwzlwg8V9vK7jxEf_z_YnqnTOMSIoSqy8x42HG0Meta } from "/codebuild/output/src2604562234/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexcMsvxXa4bJKkA5ihhoq3JwFlh_45S5MoFIVI2tK4EDsjkMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmhEGzEoxCOpqgER5eyVC9oPPHBHrYpxCcCRLDqUha07MMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completejNri0BaUIwRpwGMS0_LdcjtS_QrC65OT8cPwveAI5h4Meta } from "/codebuild/output/src2604562234/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexRFh_454lroCpaC0PW8HYmNjNXFHLk0LJnjqXZCbv3Y35sMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_934EjY3COfgZHhwI6w1kudPvLxhNnfWtpy32t3oGgX80MMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeqNzg3gFv3S3TX_456gmD2RKiU0JqhHLxAMkXa1RMPSxrYMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasB5Q8xQPYk7pgjLrHTvxX0EXsf28FycCUA8IdA81NdbsMeta } from "/codebuild/output/src2604562234/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplefF3x8dOLoHD28hcuaWCiXQJ2wCUrICbcGcPP9O1RovcMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailhwQH0ctncTkozgVOcI2KQ55uvvLmJkJ1gedy8S9r91kMeta } from "/codebuild/output/src2604562234/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmQe_45tPiC1gGbPTL0Lb2yJ7lSrZRMQJJjFfq_452SDr5V9YMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consenttAhGMoSkIfaj_45kvWNy2bGZjSH_45jpmCn7JLWUBENUqDIMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmxYHdxMOFy3Cq5DVbBUAmvxqqhEdE5KlPn2BO3uxOYX4Meta } from "/codebuild/output/src2604562234/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateN7ER_45NHtY9XOYKc5H2XAzjOZ9k5lvI3ou0YahQFxC0UMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completehsvFfCe5gJqmx87voh55kKtDilUzjLhRqybyMYRsaVwMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeU5k8XY9Y1rxvorfiD_45ENwlRlqAojhCYaRoAzOMOElosMeta } from "/codebuild/output/src2604562234/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordgkKXdq5fJDbNgMlx3ojpXPV_45ya4x0R_4cRYdyb2EIX8Meta } from "/codebuild/output/src2604562234/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias4uJZXn1ujFvU3wRyOgpTERgI41AMShP4SIO8R8gnVCUMeta } from "/codebuild/output/src2604562234/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeryus8oww3q0EBOa1Y6j8Rb5wNQXxOBPPJ5sUlRUny7LcMeta } from "/codebuild/output/src2604562234/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeEb_L_45CYjq_dGdkblHjNXfMeWz7GBEKZ8cVcRmnGF1kkMeta } from "/codebuild/output/src2604562234/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexKU62n6qnT7wg2UToCv3oXw9cX1VnAbXee8uqgbu9lkkMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexVyfkfhPBuOQfRhu5IAPXwVkxasTORAwrAaLTWSaVAtMMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index7Iz68RZlYhFnj9fXOloSh1DPtNT067oUgf5Nq8qpv8kMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexN6ig3QMGrWVnyuycGwTDyWa8irLVtF5MfYXhNhQvcuYMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatea72_45l_ky_M2SGgr_4561LjtJibromERTK9QcJyFUfal7sMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeypuyDJUH5jRDzuSJhI_45_454Xw4ZFME_45rrly3iEkfRZ1T4Meta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmpcFCa_4a2AQd8MOHlCTXV6kpGS8HDLQ4uQovQJXAC1YMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index0EW9bUvSb1cTEdy8VtwBm3hh07kg_45uPMgMbp3W42WooMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completewjzqPMert7iWM842XzsqE1eQwiH4fV0OiuLTMT7eNBIMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateKmCv3KlS1yLf3YR_RKyhmeLucQGnEXVUObOZ_45Zl3SYIMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexkXnYhLvQ7rbdyO6yWNlMZ_A3ygtWl_dIR9E0cETK3mAMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexSRAPOSLSmHArn4UhvJjGs84O1Bz_Afx9e205TKKqV9MMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeEdgFU8h1D_jdmBYo_45y6rnGK_45R1m8LSTnsMA9dMXmaloMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexZHB5gQiVmxyb9yjuPbg0LqxNObIUpZGrZyEXeHbbvQAMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codei2olNZLbhbNMAJgvcivPLAUZrPxc_45IxEMLwi232Or8IMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexFJNdIjJ_BPQOK8TCq3iFwZjyoYlBbqh6rtgg2AXUzIcMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexzFsj4B4pvQeiREfVgFI4xwsIlcsZ5xo_45hlZyN_bG91EMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexYfHhOlMO54M0w2Jl_ZD6WGmP630emKWfpDmmxXpVOxMMeta } from "/codebuild/output/src2604562234/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateBoNqED8bCcdwxqs22YGJAktqXUGpsJCFZb0mwfX_CP0Meta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmDIQFydh8FECeamNKyAiF5maufotF1EVDYlUZ3jAunFwMeta } from "/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuypqbJzNE1j7m0uEKeHUpARnT3HStZ62JmEImt4YMBwkMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexouF9_0u07tkKWP0fVYb8QSX1XR85jbRqmpUIyaWDpI4Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexwsh449Ck1QwGknvslxowG7ql4wnqkaJhkcu4zER5qMQMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexhe7gHpDDhDV87G_1XKUh34lQrvqIxwVttbHGv3mB8o8Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexOlSUEua13u_UUrD4llpRJZdea5mR0utwDwQZ5QrBuBAMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexvNszoyNTV2swXJmvAkvkDTVNgCW3MVryysXjRWhHtDsMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index0pPJmi_45RXEu_45ZHd3haSe7wIRZhnMigBjzKZxFHodRpQMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmpuuRZVnIb8iED3QfUeYwjnTKz9jXaqwSZsqIW3APyJgMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm_45bY1jwcLK8ddH5TI_45vt7TY2vy6jvVcSOd8qj6w15eHQMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completezK5_icwpfxcG3BwoAxIOUpdfTrTisqYFfoNZch3jLoIMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerHITeyxU9jKADIjZm_45fnDzu4U8S_KPSDhsYatPMshVKMMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmbxNGGy2HZesYuLmsr5ENVLkbe4qdejk1DN5Q2Cptw2wMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codejLQ037v8TUu4dP7jKPzyWaHbhcaQgrxqx4g7V1woDK4Meta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeL1_oW3hhjHw_45eSX88NtXGNfHcNvetYMouL3yL0sWvrsMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeeS2gYtXJHCtofytaToUI_45TSTcUMWOCCH7ZzhP_459NJ8sMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerUSBG2D27PyerU_45NziaVSHF_XmxT7vLwJhpPRVY1Rc4AMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmhEGzEoxCOpqgER5eyVC9oPPHBHrYpxCcCRLDqUha07MMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completejNri0BaUIwRpwGMS0_LdcjtS_QrC65OT8cPwveAI5h4Meta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexRFh_454lroCpaC0PW8HYmNjNXFHLk0LJnjqXZCbv3Y35sMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeqNzg3gFv3S3TX_456gmD2RKiU0JqhHLxAMkXa1RMPSxrYMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplefF3x8dOLoHD28hcuaWCiXQJ2wCUrICbcGcPP9O1RovcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailhwQH0ctncTkozgVOcI2KQ55uvvLmJkJ1gedy8S9r91kMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmQe_45tPiC1gGbPTL0Lb2yJ7lSrZRMQJJjFfq_452SDr5V9YMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consenttAhGMoSkIfaj_45kvWNy2bGZjSH_45jpmCn7JLWUBENUqDIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmxYHdxMOFy3Cq5DVbBUAmvxqqhEdE5KlPn2BO3uxOYX4Meta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completehsvFfCe5gJqmx87voh55kKtDilUzjLhRqybyMYRsaVwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeU5k8XY9Y1rxvorfiD_45ENwlRlqAojhCYaRoAzOMOElosMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordgkKXdq5fJDbNgMlx3ojpXPV_45ya4x0R_4cRYdyb2EIX8Meta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeryus8oww3q0EBOa1Y6j8Rb5wNQXxOBPPJ5sUlRUny7LcMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeEb_L_45CYjq_dGdkblHjNXfMeWz7GBEKZ8cVcRmnGF1kkMeta || {},
    component: () => import("/codebuild/output/src2604562234/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2604562234/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]